import { render, staticRenderFns } from "./location-edit.vue?vue&type=template&id=2937944b"
import script from "./location-edit.vue?vue&type=script&lang=js"
export * from "./location-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports